import {classNames} from '@cohort/shared-frontend/utils/classNames';
import React from 'react';

interface DigitalAssetTitleBlockProps {
  pretitle: string;
  title: string;
  subtitle: string;
  hasDarkBg: boolean;
  additionnalCssStyleOnAccent?: React.CSSProperties;
  testId?: string;
}

const DigitalAssetTitleBlock: React.FC<DigitalAssetTitleBlockProps> = ({
  pretitle,
  title,
  subtitle,
  hasDarkBg,
  additionnalCssStyleOnAccent,
  testId,
}): React.ReactElement => {
  return (
    <div>
      <div
        data-testid={testId !== undefined ? `pre-title-${testId}` : ''}
        style={additionnalCssStyleOnAccent}
        className={classNames(
          hasDarkBg ? 'text-white/50' : 'text-black/50',
          'inline-flex w-full items-center justify-center text-center text-lg leading-tight md:justify-start md:text-left'
        )}
      >
        {pretitle}
      </div>
      <h2
        data-testid={testId !== undefined ? `title-${testId}` : ''}
        className={classNames(
          hasDarkBg ? 'text-white' : 'text-gray-900',
          'w-full justify-center text-center text-xl font-bold tracking-tight sm:text-3xl md:justify-start md:text-left'
        )}
      >
        {title}
      </h2>
      <div
        data-testid={testId !== undefined ? `subtitle-${testId}` : ''}
        className={classNames(
          'inline-flex w-full items-center justify-center break-words text-center text-lg leading-tight md:justify-start md:text-left',
          hasDarkBg ? 'text-white/50' : 'text-black/50'
        )}
      >
        {subtitle}
      </div>
    </div>
  );
};

export default DigitalAssetTitleBlock;
